import SectionHead from "./SectionHead";
import { topicWall } from "@/mocks/homeData";

export default function TopicWall() {
  return (
    <section id="topics" className="px-4 py-12 md:px-10 md:py-16">
      <SectionHead
        index="03"
        title="话题墙"
        en="Topic Wall"
        desc="站内讨论被归拢成一个个词条。点进去，就能看到这一条下面的全部更新与衍生话题。"
      />

      <div className="flex flex-wrap gap-3">
        {topicWall.map((topic, idx) => (
          <a
            key={topic.name}
            href="#topics"
            className={`group inline-flex cursor-pointer items-baseline gap-2 rounded-full border px-4 py-2.5 transition-colors ${
              idx % 5 === 0
                ? "border-accent-300 bg-accent-50 hover:border-accent-500"
                : "border-background-300 bg-background-50 hover:border-primary-400 hover:bg-primary-50"
            }`}
          >
            <span
              className={`whitespace-nowrap text-sm transition-colors ${
                idx % 5 === 0
                  ? "text-accent-900 group-hover:text-accent-700"
                  : "text-foreground-800 group-hover:text-primary-700"
              }`}
            >
              {topic.name}
            </span>
            <span className="whitespace-nowrap font-label text-[11px] text-foreground-400">
              {topic.count}
            </span>
          </a>
        ))}
      </div>

      <div className="mt-10 w-full overflow-hidden rounded-lg bg-background-100 md:mt-14">
        <div className="h-[160px] w-full md:h-[230px]">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20layered%20paper%20collage%20of%20warm%20cream%2C%20olive%20and%20crimson%20geometric%20shapes%2C%20subtle%20print%20texture%20and%20torn%20edges%2C%20soft%20diffuse%20lighting%2C%20minimalist%20magazine%20spread%20background%2C%20generous%20negative%20space%2C%20no%20text%2C%20refined%20editorial%20art%20direction%2C%20harmonious%20restrained%20palette&width=1600&height=400&seq=heiliaozhan-band-03&orientation=landscape"
            alt="黑料总站话题墙视觉装饰 · 站内话题与标签聚合"
            title="黑料总站 话题墙 标签聚合"
            className="h-full w-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}